import { render, staticRenderFns } from "./bookingConsigneeFormatAddress.vue?vue&type=template&id=1b621bac&scoped=true&"
import script from "./bookingConsigneeFormatAddress.vue?vue&type=script&lang=js&"
export * from "./bookingConsigneeFormatAddress.vue?vue&type=script&lang=js&"
import style0 from "./bookingConsigneeFormatAddress.vue?vue&type=style&index=0&id=1b621bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b621bac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b621bac')) {
      api.createRecord('1b621bac', component.options)
    } else {
      api.reload('1b621bac', component.options)
    }
    module.hot.accept("./bookingConsigneeFormatAddress.vue?vue&type=template&id=1b621bac&scoped=true&", function () {
      api.rerender('1b621bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/bookingConsigneeFormatAddress.vue"
export default component.exports